import { combineReducers } from 'redux';
import authReducer from './authReducer';
import ecpReducer from './ecpReducer';
import applicantReducer from './applicantReducer';
import applicationReducer from './applicationReducer';
import errorReducer from './errorReducer';
import childReducer from './childReducer';
import docs from './docFilesReducer';
import { getDataFromDirectories } from './getSelectDataReducer';
import getChildrenData from './childrenReducer';
import getDocument from './uploadDocumentReducer';
import isEdle from './isIdleReducer';
import { loadingReducer } from './loadingReducer';
import feature from './feature.reducer';

export default combineReducers({
  auth: authReducer,
  applicant: applicantReducer,
  application: applicationReducer,
  errors: errorReducer,
  directories: getDataFromDirectories,
  child: childReducer,
  children: getChildrenData,
  documentChild: getDocument,
  isFatching: loadingReducer,
  isEdle,
  eusign: ecpReducer,
  docs,
  feature
});
